<template>
  <AppModalPopup :popupId modal-type="bottom" @update:closeCallBack="loginPageCheck" class="verification">
    <template #header>
      <!-- pub 10-14 tabindex="0" 삭제필요 -->
      <h1 class="t-center">본인인증 수단</h1>
    </template>
    <template #default>
      <h2 class="desc-title">인증이 필요한 서비스 입니다. <br/>본인인증 수단을 선택해 주세요.</h2>
      <div class="easy-login-btns">
        <template v-if="menuType === 'phone'">
          <a href="#" title="새창열림" class="btn-login phone" @click.prevent="showPhoneAndIpinPop('phone')">
            <strong>휴대전화</strong>
          </a>
          <a href="#" title="새창열림" class="btn-login ipin" @click.prevent="showPhoneAndIpinPop('ipin')">
            <strong>아이핀 인증</strong>
          </a>
        </template>
        <template v-else>
          <a href="#" title="새창열림" class="btn-login phone" @click.prevent="showPhoneAndIpinPop('phone')">
            <strong>휴대전화</strong>
          </a>
          <a id="official" href="#" class="btn-login old-cert" @click.prevent="showOfficialPop">
            <strong>공동인증서(구 공인인증서)</strong>
            <span v-if="isLogin"
                  class="badge-icon"
                  :class="!loginMethodObj ? 'type-gray' : ''">
            {{ loginMethodObj ? '등록' : '미등록' }}
          </span>
          </a>
          <a id="financial" href="#" class="btn-login financial-cert" @click.prevent="certMethod.handleFinanceClick(financeCallback)">
            <strong>금융결제원 금융인증서</strong>
          </a>
          <a href="#" id="simpleLogin" class="btn-login simple" @click.prevent="certMethod.handleSimpleClick(simpleCallback)">
            <strong>간편인증(카카오,네이버)</strong>
          </a>
          <a href="#" title="새창열림" class="btn-login ipin" @click.prevent="showPhoneAndIpinPop('ipin')">
            <strong>아이핀 인증</strong>
          </a>
        </template>
      </div>
    </template>
  </AppModalPopup>

</template>

<script setup>
import AppModalPopup from "@/components/atoms/AppModalPopup.vue";
import {computed, inject} from "vue";
import {useMyPageStore} from "@/services/store/myPageStore";
import {togglePop} from "@/utils/commonUi";
import {useMemberStore} from "@/services/store/memberStore";
import {useRoute, useRouter} from "vue-router";
import memberApi from "@/services/api/memberApi";
import certMethod from "@/utils/certMethod";
import tokenService from "@/services/token.service";

/*--------------------------------공통------------------------------------*/

const router = useRouter();

const route = useRoute();

const store = useMyPageStore();

const memberStore = useMemberStore();

const component = inject('$component');

const setCallback = inject('setCallback');

//인증수단 목록
const loginMethodObj = computed(() => {
  return store.myPage.loginMethod.officialAuth;
});

//로그인 여부
const isLogin = computed(() => {
  return memberStore.member.status.isLogin
})

const props = defineProps({
  popupId: {
    type: String,
    default: 'certificatePop'
  },
  menuType: {
    type: String,
    default: 'all'
  }
})

//인증 팝업을 닫을 시 이벤트
const loginPageCheck = () => {
  window.removeEventListener('message', verifyPhoneAndIpin);
  if (props.popupId === 'certificatePop2') {
    //로그인 화면에서 팝업 닫을 시 이벤트 provide 본인인증 팝업만
    if (route.path.includes('login')) {
      router.replace({name: 'Main'});
    }
    memberStore.member.noticeCheck = false;
  }
}

//에러메세지
const errAlert = (err) => {
  if (err.response.data.failureMessage.exceptionCode === 'USER_CAN_NOT_MODIFY_OTHER_USER') {
    component.simpleAlert('현재 접속한 아이디와 본인인증 결과가 맞지 않습니다. \n 확인 후 다시 인증해 주세요.');
  } else {
    component.simpleAlert(err.response.data.failureMessage.exceptionMessage)
  }
}

/*--------------------------------간편인증------------------------------------*/

//간편인증 콜백
const simpleCallback = async (res) => {
  try {
    let jsonParse = JSON.parse(res);
    const obj = {
      txId: jsonParse.txId,
      token: jsonParse.token,
    }
    const data = isLogin.value ? await memberApi.verifyMyCertSimple(obj) : await memberApi.verifyCertSimple(obj)
    togglePop(props.popupId, false);
    tokenService.updateToken(data);
    setCallback();
  } catch (err) {
    errAlert(err);
  }
}

/*--------------------------------공인인증서------------------------------------*/

//공인 본인확인 팝업 호출
const showOfficialPop = () => {
  if (isLogin.value) {
    if (!loginMethodObj.value) {
      togglePop(props.popupId, false);
      component.simpleAlert('공동(공인)인증서가 등록되어있지 않습니다. \n 마이페이지 > 환경설정 > 인증/보안에서 등록해 주세요.');
      component.alert.fn.fnSelect = function () {
        router.push({name: 'mySecurity'})
      }
      component.alert.fn.fnClose = function () {
        router.push({name: 'mySecurity'})
      }
      return false;
    }
  }
  certMethod.handleOfficialClick(officialCallback);
}

//공동인증서 본인인증
const officialCallback = async (res) => {
  if (res.status === 1) {
    try {
      const data = isLogin.value ? await memberApi.verifyMyCertOfficial(res) : await memberApi.verifyCertOfficial(res)
      tokenService.updateToken(data);
      togglePop(props.popupId, false);
      setCallback();
    } catch (err) {
      errAlert(err);
    }
  }else if (res.status === 0){
    document.getElementById('official').focus();
  }
}

/*--------------------------------금융인증서------------------------------------*/

const financeCallback = async (res, context) => {
  if (res.status === 1) {
    try {
      const data = isLogin.value ? await memberApi.verifyMyCertFinance(res, context) : await memberApi.verifyCertFinance(res, context)
      togglePop(props.popupId, false);
      tokenService.updateToken(data);
      setCallback();
    } catch (err) {
      errAlert(err);
    }
  }else if (res.status === 0){
    document.getElementById('financial').focus();
  }
}

/*--------------------------------휴대폰, 아이핀 인증------------------------------------*/

//휴대폰, 아이핀 본인인증
const showPhoneAndIpinPop = (type) => {
  window.addEventListener('message', verifyPhoneAndIpin);
  if (type === 'phone') {
    certMethod.handleMobileAuthClick('verify');
  } else {
    certMethod.handleIpinAuthClick('verify');
  }
}

const verifyPhoneAndIpin = async (event) => {
  let data //본인인증 토큰값
  const params = new URLSearchParams(event.data.params)

  if ((event.data.source === 'sciPccCallBack' || event.data.source === 'sciCbaCallBack') && params.get('customValue') === 'verify') {
    try {
      const retInfo = {retInfo: params.get('retInfo')} //retInfo 값
      if (event.data.source === 'sciPccCallBack') {
        /*휴대폰인증 본인인증 관련*/
        data = isLogin.value ? await memberApi.verifyMyCellPhone(retInfo) : await memberApi.verifyCellPhone(retInfo);
      } else if (event.data.source === 'sciCbaCallBack') {
        /*아이핀 본인인증 관련*/
        data = isLogin.value ? await memberApi.verifyMyIPin(retInfo) : await memberApi.verifyIPin(retInfo);
      }
      togglePop(props.popupId, false);
      tokenService.updateToken(data);
      setCallback(event.data.source, params);
    } catch (err) {
      errAlert(err);
    } finally {
      //휴대폰, 아이핀 이벤트 삭제 (삭제가 없으면 중복이벤트가 발생)
      window.removeEventListener('message', verifyPhoneAndIpin);
    }
  }
}
</script>
